import { Mic } from 'lucide-react';
import type { AudioInputOption } from '../lib/audioInput';
import './AudioInputPicker.css';

interface Props {
  devices: AudioInputOption[];
  selectedId: string;
  activeLabel: string;
  switching: boolean;
  error: string;
  compact?: boolean;
  disabled?: boolean;
  onChange: (deviceId: string) => void;
}

export function AudioInputPicker({ devices, selectedId, activeLabel, switching, error, compact = false, disabled, onChange }: Props) {
  const transientStatus = error || (switching ? 'wechselt…' : '');
  const defaultLabel = compact && !selectedId && activeLabel
    ? `System · ${activeLabel}`
    : 'Systemstandard';

  return (
    <div className={`audio-input-picker${compact ? ' compact' : ''}${error ? ' has-error' : ''}`} title={error || `Aktiver Eingang: ${activeLabel || 'noch nicht verbunden'}`}>
      <Mic size={12} aria-hidden />
      <select
        aria-label="Mikrofoneingang"
        value={selectedId}
        disabled={disabled || switching}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">{defaultLabel}</option>
        {selectedId && !devices.some((device) => device.deviceId === selectedId) && (
          <option value={selectedId}>Gespeichertes Mikrofon</option>
        )}
        {devices.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>{device.label}</option>
        ))}
      </select>
      {(!compact || transientStatus) && (
        <span className="audio-input-active" aria-live="polite">
          {transientStatus || activeLabel || 'beim Start gewählt'}
        </span>
      )}
    </div>
  );
}
